import React from 'react';
import NeighborhoodPainPost from '../components/NeighborhoodPainPost';

const BlogPostOakParkPain = () => (
  <NeighborhoodPainPost
    data={{
      neighborhood: 'Oak Park',
      slug: 'back-and-neck-pain-massage-oak-park',
      image:
        'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1600&auto=format&fit=crop&q=80',
      driveMinutes: '10–15 minutes',
      driveNote:
        'the drive from Oak Park to 2528 I Street via Broadway or Stockton Boulevard is short and direct',
      routes: [
        'From Oak Park proper: ~10 minutes north via Broadway',
        'From near Broadway/34th: ~8–10 minutes via 21st or 19th Street',
        'From the McClatchy High area: ~12 minutes via Broadway',
      ],
      nearbyAreas: [
        'Oak Park, Sacramento',
        'Curtis Park, Sacramento',
        'Elmhurst, Sacramento',
        'Tahoe Park, Sacramento',
        'Midtown Sacramento',
      ],
      pageTitle:
        'Back and Neck Pain Massage in Oak Park | Ayumi Suzuki',
      hookLine:
        'Struggling with chronic back or neck pain and searching for a certified massage therapist near Oak Park?',
      dataTestId: 'oak-park-pain-blog-page',
    }}
  />
);

export default BlogPostOakParkPain;
